
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/toolbox'
import 'echarts/lib/component/grid'
import 'zrender/lib/canvas/canvas'
import numbro from 'numbro'

import TextBox from '@/components/TextBox.vue'

export default {
  components: {
    'v-chart': ECharts,
    TextBox
  },
  props: {
    // Finished grid points: [{ budget, mix: { channel: % } }], sorted by budget.
    rows: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    colors: {
      type: Object,
      required: false,
      default: () => ({})
    },
    // Display name of each channel key.
    labels: {
      type: Object,
      required: false,
      default: () => ({})
    },
    spendUnitName: {
      type: String,
      required: false,
      default: ''
    },
    exportImageName: {
      type: String,
      required: false,
      default: 'Media Mix at different Budget Levels'
    },
    height: {
      type: Number,
      required: false,
      default: 400
    }
  },
  computed: {
    channels () {
      const channels = []
      this.rows.forEach(row => {
        Object.keys(row.mix).forEach(channel => {
          if (channels.indexOf(channel) === -1) channels.push(channel)
        })
      })
      return channels.sort()
    },
    options () {
      return {
        toolbox: {
          feature: {
            saveAsImage: { type: 'png', name: this.exportImageName, title: this.$t('components.BarChart.saveAsImage') }
          },
          showTitle: false
        },
        // No legend: the tooltip names each channel, and the colours match the rest of the app.
        legend: { show: false },
        grid: { left: 60, right: 30, top: 30, bottom: 50 },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: this.formatTooltip
        },
        xAxis: {
          type: 'category',
          name: `${this.$t('components.budgetSimulator.TotalSaturationCurve.budget')} (${this.spendUnitName})`,
          nameLocation: 'middle',
          nameGap: 30,
          data: this.rows.map(row => this.formatValue(row.budget))
        },
        yAxis: {
          type: 'value',
          max: 100,
          splitLine: { show: false },
          axisLabel: { formatter: '{value}%' }
        },
        series: this.channels.map(channel => ({
          name: this.labels[channel] || channel,
          type: 'bar',
          stack: 'mix',
          barMaxWidth: 60,
          itemStyle: { color: this.colors[channel] },
          data: this.rows.map(row => Math.round(100 * (row.mix[channel] || 0)) / 100)
        }))
      }
    }
  },
  methods: {
    formatValue (value) {
      return numbro(value).format({ average: true, mantissa: 1, optionalMantissa: true })
    },
    formatTooltip (params) {
      let tooltip = `<b>${params[0].name} ${this.spendUnitName}</b><br>`
      params.slice().reverse().forEach(param => {
        if (param.value > 0) {
          tooltip += `${param.marker}${param.seriesName}: ${numbro(param.value).format({ mantissa: 1 })}%<br>`
        }
      })
      return tooltip
    }
  }
}
